import { Marquee } from "@/components/primitives";

const WORDS = ["Plan", "Operate", "Collaborate", "Grow", "One Workspace", "AI-powered", "Connected", "For Founders"];

export default function MarqueeStrip() {
  return (
    <section className="relative border-y border-border bg-card/30 py-8" data-testid="marquee-strip">
      <Marquee items={WORDS} />
    </section>
  );
}
